import React from 'react';
import css from"./HR.module.css"
const Hr = () => {
    return (
            <hr className={css.hr}/>
    );
};

export default Hr;